/**
 * uploadHandlers.ts
 * 各種アップロード処理メソッド
 * App.vue から切り出し
 */

import {
  extractFirstFeaturePropertiesAndCheckCRS,
  addDraw,
  pmtilesGenerate,
  googleGeocode,
  sanitizeLongText,
  delay0,
  jgd2000ZoneToWgs84,
} from '@/js/downLoad'
import { kml } from '@tmcw/togeojson'
import store from '@/store'
import { consumeToken } from '@/js/tokenService'

type VM = any

export function uploadChibanzu(vm: VM) {
  vm.dialogForChibanzyOrDraw = false
  async function aaa () {
    vm.s_chibanzuPropaties = await extractFirstFeaturePropertiesAndCheckCRS(vm.s_geojsonFile)
    vm.s_showChibanzuDialog = true
  }
  aaa()
}

export async function uploadMyroomKml(vm: VM) {
  // KMLインポート（マイルーム）: 1pt
  const tokenResult = await consumeToken('import_kml')
  if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
  vm.dialogForDraw = false
  const layerName = vm.s_geojsonFile.name.split('.')[0]
  const label = 'name'
  vm.$store.commit('setPmtilesMaximum', 16) // KMLのデフォルト最大ズーム

  // KMLは既にgeojsonForDrawにパースされているので、それをBlobに変換
  const geojsonBlob = new Blob(
    [JSON.stringify(vm.geojsonForDraw)],
    { type: 'application/json' }
  )
  const geojsonFile = new File([geojsonBlob], layerName + '.geojson', { type: 'application/json' })

  const id = await pmtilesGenerate (
      null,
      layerName,
      '',
      geojsonFile
  )
  vm.s_pmtiles0Id = id
  vm.s_pmtiles0Name = layerName
  vm.$store.commit('setPmtilesFirstSave', true)
  vm.openPaintEditorWindow()
}

export async function uploadDrawKml(vm: VM) {
  // KMLインポート（ドロー）: 1pt
  const tokenResult = await consumeToken('import_kml')
  if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return
  vm.dialogForDraw = false
  // geometryとpropertiesが有効なフィーチャーのみをフィルタリング
  vm.geojsonForDraw.features = vm.geojsonForDraw.features.filter((feature: any) => {
    return feature.geometry && feature.properties
  })
  vm.geojsonForDraw.features.forEach((feature: any) => {
    const geoType = feature.geometry.type
    const props = feature.properties
    props.label = props.name
    geoType === 'Polygon' ? props.color = 'rgba(0,0,0,0.1)' :  props.color = 'black'
    props.offsetValue = [0.6, 0]
    props.textAnchor = 'left'
    props.textJustify = 'left'
  })
  addDraw(vm.geojsonForDraw, true, false)
}

// 共通: 1行からプロパティを組み立てる
function buildCsvRowProps(vm: VM, row: any) {
  const props = Object.fromEntries(
      vm.csvColumns.map((col: string) => [col, row[col]])
  )
  const pointColor = row[vm.csvColorColumn] || 'black'
  props.label = row[vm.csvLabelColumn] || ''
  props.longText = sanitizeLongText(row[vm.csvLongTextColumn]) || ''
  props.color = 'black'
  props.offsetValue = [0.6, 0]
  props.textAnchor = 'left'
  props.textJustify = 'left'
  props['point-color'] = pointColor
  if (row[vm.csvPictureUrlColumn]) {
    props.pictureUrl = row[vm.csvPictureUrlColumn]
  }
  return props
}

export async function uploadDrawCsv(vm: VM) {
  if (!vm.csvLabelColumn) {
    alert('ラベルの列が選択されていません。')
    return
  }

  // CSVインポート: 8pt （ジオコーディング/緯度経度/公共座標系 共通）
  const tokenResult = await consumeToken('import_csv')
  if (!tokenResult.success && tokenResult.error !== 'NETWORK_ERROR_IGNORED') return

  const mode = vm.csvImportMode || 'geocode'

  // --- タブ2: WGS84 緯度経度 ---
  if (mode === 'wgs84') {
    if (!vm.csvLonColumn || !vm.csvLatColumn) {
      alert('経度・緯度の列を選択してください。')
      return
    }
    vm.dialogForDrawCsv = false
    const features = []
    let skipped = 0
    for (const row of vm.csvRecords) {
      const lon = parseFloat(row[vm.csvLonColumn])
      const lat = parseFloat(row[vm.csvLatColumn])
      if (isNaN(lon) || isNaN(lat)) { skipped++; continue }
      features.push({
        type: 'Feature',
        properties: buildCsvRowProps(vm, row),
        geometry: { type: 'Point', coordinates: [lon, lat] },
      })
    }
    if (skipped > 0) console.warn(`[uploadDrawCsv] ${skipped} rows skipped (invalid lon/lat)`)
    addDraw({ type: 'FeatureCollection', features }, true, false)
    return
  }

  // --- タブ3: 公共座標系（平面直角座標系）---
  if (mode === 'jprcs') {
    if (!vm.csvXColumn || !vm.csvYColumn) {
      alert('X・Y の列を選択してください。')
      return
    }
    const zone = Number(vm.csvJprcsZone)
    if (!(zone >= 1 && zone <= 19)) {
      alert('座標系（系番号）を 1〜19 で指定してください。')
      return
    }
    vm.dialogForDrawCsv = false
    const features = []
    let skipped = 0
    for (const row of vm.csvRecords) {
      const x = parseFloat(row[vm.csvXColumn])
      const y = parseFloat(row[vm.csvYColumn])
      if (isNaN(x) || isNaN(y)) { skipped++; continue }
      try {
        // 平面直角座標系: X=北方向, Y=東方向 → proj4 は (east, north) = (y, x)
        const { lon, lat } = jgd2000ZoneToWgs84(zone, y, x)
        features.push({
          type: 'Feature',
          properties: buildCsvRowProps(vm, row),
          geometry: { type: 'Point', coordinates: [lon, lat] },
        })
      } catch (e) {
        skipped++
        console.warn('[uploadDrawCsv] jprcs convert failed', e)
      }
    }
    if (skipped > 0) console.warn(`[uploadDrawCsv] ${skipped} rows skipped (invalid X/Y)`)
    addDraw({ type: 'FeatureCollection', features }, true, false)
    return
  }

  // --- タブ1: ジオコーディング（従来動作）---
  if (!vm.csvAddressColumn) {
    alert('アドレスの列を選択してください。')
    return
  }
  store.commit('setLoading2', true)
  store.commit('setLoadingMessage', 'ジオコーディング中 (Google)')
  vm.dialogForDrawCsv = false
  const features = []
  const len = vm.csvRecords.length
  for (let i = 0; i < len; i++) {
    const row = vm.csvRecords[i]
    const address = (row[vm.csvAddressColumn] || '').replace(/^〒\d{3}-\d{4}\s*/, '').trim()
    if (!address) continue
    const geo = await googleGeocode(address)
    if (geo) {
      features.push({
        type: 'Feature',
        properties: buildCsvRowProps(vm, row),
        geometry: { type: 'Point', coordinates: geo.geometry.coordinates },
      })
    }
    store.commit('setLoadingMessage', (i + 1) + '/' + len + ' ' + row[vm.csvLabelColumn] + ' ' + (geo ? '成功' : '失敗'))
    await delay0(50) // Google API の QPS 制限に配慮
  }
  addDraw({ type: 'FeatureCollection', features }, true, false)
  store.commit('setLoading2', false)
}

export async function uploadMyLayer(vm: VM) {
  if (!vm.s_gazoName) {
    alert('レイヤー名を記入してください')
    return
  }
  vm.dialogForChibanzyOrDraw = false
  vm.dialogForLayerName = false
  vm.s_propnames = await extractFirstFeaturePropertiesAndCheckCRS(vm.s_geojsonFile)
  // const layerName = vm.s_geojsonFile.name.split('.')[0]
  const layerName = vm.s_gazoName
  const label = 'name'
  const id = await pmtilesGenerate (
      null,
      layerName,
      '',
      vm.s_geojsonFile,
  )
  vm.s_pmtiles0Id = id
  vm.s_pmtiles0Name = vm.s_gazoName
  vm.$store.commit('setPmtilesFirstSave', true)
  vm.openPaintEditorWindow()
}

